import { useMemo } from "react";
import ROUTES from "../../../configs/routesConfig";
import { NavigateFunction, useNavigate } from "react-router-dom";

export const useAccountsInProgress = (draft: any, other: any) => {
  const navigate: NavigateFunction = useNavigate();

  const draftProps = useMemo(
    () => ({
      value: draft,
      label: "Draft Accounts",
      redirectTo: () => navigate(`${ROUTES.ACCOUNTS}?statusFilter=7`),
    }),
    [draft, navigate],
  );

  const otherProps = useMemo(
    () => ({
      value: other,
      label: "Other Accounts",
      redirectTo: () => navigate(ROUTES.OTHER_ACCOUNTS),
    }),
    [navigate, other],
  );

  const data = useMemo(
    () => ({
      draftProps,
      otherProps,
    }),
    [draftProps, otherProps],
  );

  return { data };
};
